import React from 'react'
import { saveBufferAsFile } from '../../utils/functions';

const JarDownloadContent = ({ fileName, content }: { fileName: string, content: ArrayBuffer }) => {

  // download the jar file
  const download = () => {
    saveBufferAsFile(content, fileName, 'application/java-archive');
  }

  return (
    <div className='flex-1 flex justify-center flex-col items-center scroller'>
      <div className='flex-1 flex items-center justify-center max-w-xl w-full my-10'>
        <button className='bg-emerald-500 active:bg-emerald-600 p-1 px-4 rounded text-sm font-bold' onClick={download}>Download {fileName}</button>
      </div>
    </div>
  )
}

export default JarDownloadContent